import { Button as ButtonMUI } from '@mui/material';
import classNames from 'classnames';
import { useRouter } from 'next/navigation';
import { ButtonProps } from './Button.interface';
import classes from './Button.module.scss';
const Button: React.FC<ButtonProps> = ({
  children,
  id,
  variant = 'primary',
  onClick,
  disabled,
  size = 'medium',
  endIcon = null,
  startIcon = null,
  href,
  target = '_self',
  className,
  type = 'button',
  aria
}) => {
  const router = useRouter();
  const handleClick = () => {
    if (disabled) return;
    if (onClick) {
      onClick();
    }
    if (href) {
      if (target === '_blank' || href.startsWith('http://') || href.startsWith('https://') || href.startsWith('www.')) {
        window.open(href, target);
      } else {
        router.push(href);
      }
    }
  };
  const ariaProps = aria ? {
    'aria-label': aria.label,
    'aria-describedby': aria.describedby,
    'aria-controls': aria.controls,
    'aria-expanded': aria.expanded,
    'aria-haspopup': aria.haspopup,
    'aria-hidden': aria.hidden
  } : {};
  const buttonContent = <ButtonMUI id={id} className={classNames(className, {
    [classes['large-button']]: size === 'large',
    [classes['small-button']]: size === 'small'
  })} variant={variant} onClick={handleClick} disabled={disabled} endIcon={endIcon} startIcon={startIcon} type={type} {...ariaProps}>
			{children}
		</ButtonMUI>;
  return buttonContent;
};
export default Button;